export default {
  'balanceShare.roleInfo': 'Role Info',
  'balanceShare.roleName': 'Role Name',
  'balanceShare.roleCode': 'Role Code',
  'balanceShare.remark': 'Remark',
  'balanceShare.balanceShareTemplate': 'Balance Share Template',
  'balanceShare.templateName': 'Template Name',
  'balanceShare.balanceShareType': 'Balance Share Type',
  'balanceShare.cycleLimit': 'Cycle Limit',
  'balanceShare.acctItemGroup': 'Acct Item Group',
  'balanceShare.comments': 'Comments',
  'balanceShare.shareTemplate': 'Account Item Group',
  'balanceShare.ceilLimit': 'Ceil Limit',
  'balanceShare.ceilLimitUnit': 'Ceil Limit ({unit})',
  'balanceShare.dailyLimit': 'Daily Limit',
  'balanceShare.dailyLimitUnit': 'Daily Limit ({unit})',
  'balanceShare.effectiveDate': 'Effective Date',
  'balanceShare.expiryDate': 'Expiry Date',
  'balanceShare.memberList': 'Member List',
  'balanceShare.addMember': 'Add Member',
  'balanceShare.addMembers': 'Add Members',
  'balanceShare.editMembers': 'Edit Members',
  'balanceShare.editSuccess': 'Modify successfully!',
  'balanceShare.addSuccess': 'Add successfully!',
  'balanceShare.confirmDeleteMember': 'Confirm to delete member?',
  'balanceShare.deleteSuccess': 'Delete successfully!',
  'balanceShare.template': 'Share Template',
  'balanceShare.account.resource': 'Account Resource',
  'balanceShare.limit.tips': 'Please enter an integer between 1-999999999',
  'balanceShare.dailyLimitLessThanCeilLimit': 'The value of dailyCeilLimit cannot be greater than ceilLimit'
};
